import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'full-name',
  template: `<form #fullNameForm="ngForm">
                <div class="form-group">
                  <label for="firstName">{{ 'fullName.firstNameLabel' | translate }}</label>
                  <input type="text" class="form-control" id="firstName"
                         [required]="required"
                         [(ngModel)]="firstName" (ngModelChange)="this.firstNameChange.emit($event)" name="firstName"
                         #firstNameField="ngModel">

                  <div *ngIf="firstNameField.invalid && (firstNameField.dirty || firstNameField.touched)"
                       class="alert alert-danger">
                    <div *ngIf="firstNameField.errors.required">
                      {{ 'fullName.firstNameRequiredMessage' | translate }}
                    </div>
                  </div>

                  <br />

                  <div class="form-group">
                      <label for="middleName">{{ 'fullName.middleNamLabel' | translate }}</label>
                      <input type="text" class="form-control" id="middleName"
                             [(ngModel)]="middleName"  (ngModelChange)="this.middleNameChange.emit($event)" name="middleName"
                             #middleNameField="ngModel">
                  </div>

                  <div class="form-group">
                      <label for="lastName">{{ 'fullName.lastNameLabel' | translate }}</label>
                      <input type="text" class="form-control" id="lastName"
                             [required]="required"
                             [(ngModel)]="lastName" (ngModelChange)="this.lastNameChange.emit($event)" name="lastName"
                             #lastNameField="ngModel">

                      <div *ngIf="lastNameField.invalid && (lastNameField.dirty || lastNameField.touched)"
                           class="alert alert-danger">
                        <div *ngIf="lastNameField.errors.required">
                          {{ 'fullName.lastNameRequiredRequiredMessage' | translate }}
                        </div>
                      </div>
                    </div>
                </div>
             </form>`,
})
export class FullNameComponent {
  @Input() required: boolean = true;
  @Input() firstName: string;
  @Input() middleName: string;
  @Input() lastName: string;
  @Output() firstNameChange = new EventEmitter<string>();
  @Output() middleNameChange = new EventEmitter<string>();
  @Output() lastNameChange = new EventEmitter<string>();

  @ViewChild(NgForm) form;

  constructor() { }

}
